/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { motion } from 'framer-motion';
import Link from 'next/link';

export const MainNavigator = ({
  pathname,
  item,
  i,
  setActiveSidebarSubNav,
  mobileNavigationHandler,
}: {
  pathname: string;
  item: any;
  i: number;
  setActiveSidebarSubNav: React.Dispatch<React.SetStateAction<any>>;
  mobileNavigationHandler: React.Dispatch<React.SetStateAction<any>>;
}) => {
  const linkVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i: number) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.3,
      },
    }),
    exit: { opacity: 0, x: 50 },
  };
  const hasSub = item.subItems && item.subItems.length > 0;
  const isActive = pathname === item.href || (hasSub && item.subItems!.some((sub: any) => pathname.startsWith(sub.href)));
  return (
    <motion.div key={item.name} custom={i} initial='hidden' animate='visible' exit='exit' variants={linkVariants} className='relative'>
      {hasSub ? (
        <button onClick={() => setActiveSidebarSubNav(item)} className={`group flex w-full justify-between items-center px-3 py-2 rounded-md text-2xl text-neutral-100 ${isActive ? 'active font-bold' : 'font-medium'}`}>
          <p>{item.name}</p>
          <div className={`size-2 bg-neutral-100 rounded-full transition-opacity duration-300 ease-in-out ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} />
        </button>
      ) : (
        <Link href={item.href} onClick={mobileNavigationHandler} className={`group flex w-full justify-between items-center px-3 py-2 rounded-md text-2xl text-neutral-100 ${isActive ? 'active font-bold' : 'font-medium'}`}>
          <p>{item.name}</p>
          <div className={`size-2 bg-neutral-100 rounded-full transition-opacity duration-300 ease-in-out ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} />
        </Link>
      )}
    </motion.div>
  );
};
